import { Inject } from '@odinjs/odin';

import { catchRenderException, Endpoint } from '@philips-emr/hpms-stipulator-commons';
import { FieldAPI, FieldListAPI, PanelAPI } from '@philips-emr/tws-components';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnAfterFetch, OnMount } from '@philips-emr/tws-core/lib/client';
import { FetchEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import BaseController from '../BaseController';

import './contrato-dossie-info-controller.scss';
import ContratoDossieInfoService from './contrato-dossie-info-service';

@Controller({ fragment: 'contrato-dossie-info' })
class ContratoDossieInfoController extends BaseController {

  @Inject('field-list-produto')
  private fieldListProduto: FieldListAPI;

  @Inject('panel-produto')
  private panelProduto: PanelAPI;

  @Inject('field-list-sca')
  private fieldListSCA: FieldListAPI;

  @Inject('panel-sca')
  private panelSCA: PanelAPI;

  @Inject('field-list-contato')
  private fieldListContato: FieldListAPI;

  @Inject('panel-contato')
  private panelContato: PanelAPI;

  @Inject('field-cnpj-cpf')
  private fieldCpfCnpj: FieldAPI;

  @OnMount('layout-contrato-dossie-info')
  onMountContractDossierInfo(): void {
    const { nrSeqContrato } = this.historyService.getCurrentRouteParams();

    this.fetchData(Endpoint.GET.CONTRATO_DOSSIE_PRODUTOS, nrSeqContrato, this.fieldListProduto, this.panelProduto);
    this.fetchData(Endpoint.GET.CONTRACT_DOSSIER_SCAS, nrSeqContrato, this.fieldListSCA, this.panelSCA);
    this.fetchData(Endpoint.GET.CONTRACT_DOSSIER_CONTATOS, nrSeqContrato, this.fieldListContato, this.panelContato);

  }

  @OnAfterFetch('fetch-contrato')
  onAfterFetchContract(event: FetchEvent): void {
    if(!event.data) {
      return;
    }
    ContratoDossieInfoService.onAfterFetchContract((event || {}).data as any, this.fieldCpfCnpj);
  }

  private fetchData(endpoint: string, nrSeqContrato: string | number, fieldList: FieldListAPI, panel: PanelAPI): void {
    void HttpService.get<Record<string, Value>[]>(endpoint, { nrSeqContrato })
      .then(response => {
        const { body = [] } = response;

        if (body.length) {
          fieldList.setValue(body);
        } else {
          catchRenderException(() => panel.setVisible(false));
        }
      });
  }

}

export default ContratoDossieInfoController;
